<template>
  <div class="learning_details">
    <search-com @search-btn="searchBtn"></search-com>
    <div class="nav_box">
      <welfare-breadcrumb :itemBreadcrumb="itemBreadcrumb"></welfare-breadcrumb>
    </div>
    <div class="details_box">
      <div class="details_left">
        <div class="details_head">
          <img class="details_img" :src="courseDetails.coverUrl" />
          <div class="details_info">
            <p class="info_title">{{ courseDetails.courseName }}</p>
            <p class="info_text">
              <span class="info_name">课程价格</span>：
              <span class="info_con2">￥{{ courseDetails.coursePrice }}</span>
            </p>
            <p class="info_text">
              <span class="info_name">学习人数</span>：
              <span class="info_con1">{{ courseDetails.learnerCount }}</span>
            </p>
            <p class="info_text">
              <span class="info_name">课时</span>：
              <span class="info_con1">{{ courseDetails.courseDuration }}</span>
            </p>
            <p class="info_text">
              <span class="info_name">上线时间</span>：
              <span class="info_con1">{{ $moment(courseDetails.createTime).format('YYYY-MM-DD') }}</span>
            </p>
            <div class="cart">
              <div>
                <el-button
                  style="color:#fff;"
                  v-if="courseIsActive"
                  type="primary"
                  @click="addCarBtn"
                >
                  <i class="el-icon-shopping-cart-1"></i>
                  加入购物车
                </el-button>
                <el-button v-else type="info" plain disabled>
                  课程已下架
                </el-button>
              </div>
              <span class="buy_tips">加入购物车，去购物车下单</span>
            </div>
          </div>
        </div>
        <el-tabs class="course_box">
          <el-tab-pane label="课程介绍" v-if="courseDetails.tag">
            <div class="course_main" v-html="courseDetails.tag"></div>
          </el-tab-pane>
          <el-tab-pane label="课程大纲" v-if="courseDetails.outLine">
            <div class="course_main" v-html="courseDetails.outLine"></div>
          </el-tab-pane>
          <el-tab-pane label="具体章节" v-if="courseDetails.chapterList">
            <div class="chapter_list">
              <p class="chapter_item" v-for="chapterItem,index in courseDetails.chapterList" :key="index">
                <i class="chapter_icon"></i>
                <span class="chapter_title">{{chapterItem.title}}</span>
                <span class="chapter_time">{{chapterItem.timeLengthStr}}</span>
              </p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="details_right" v-if="courseDetails.teacherDto">
        <div class="teacher_box">
          <img class="teacher_img" :src="courseDetails.teacherDto.teacherFace" />
          <div class="teacher_desc">
            <p class="teacher_desc_title">讲师介绍：</p>
            <p class="teacher_desc_text" v-html="courseDetails.teacherDto.teacherTop"></p>
          </div>
        </div>
        <div class="reco_box" v-if="courseDetails.otherCourseList && courseDetails.otherCourseList.length">
          <div class="reco_head">
            <i></i>
            <span>相关推荐</span>
          </div>
          <div class="reco_list">
            <div
              class="reco_item"
              v-for="relationRecoItem in courseDetails.otherCourseList"
              :key="relationRecoItem.id"
              @click="goRecoDetails(relationRecoItem.id)"
              >
              <img :src="relationRecoItem.coverUrl" referrerpolicy="no-referrer"/>
              <div class="reco_text">
                <p class="reco_title">{{ relationRecoItem.courseName }}</p>
                <p class="reco_other">
                  <span class="reco_num">学习人数：{{ relationRecoItem.learnerCount }}</span>
                  <span class="reco_price"><i>￥{{ relationRecoItem.price }}</i>起</span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SearchCom from "@/components/welfareMallComp/SearchCom";
import WelfareBreadcrumb from "@/components/welfareMallComp/WelfareBreadcrumb";
import { getReqLoginAddCart } from "@/network/welfareMall_api";
import { getCourseInfo,AddCourseCart } from "@/network/courselearning";
import { mapState, mapMutations } from "vuex";
export default {
  name: "learningDetails",
  components: {
    WelfareBreadcrumb,
    SearchCom,
  },
  data() {
    return {
      itemBreadcrumb: [
        {
          name: "企业商城",
          to: "/welfareHome",
        },
        {
          name: "课程商城",
          to: "/learningIndex",
        },
        {
          name: "课程详情",
        },
      ],
      courseIsActive: true,
      courseDetails: {},
    };
  },
  computed: {
    // 映射
    ...mapState(["useInfo"]),
  },
  created() {
    let id = this.$route.query.courseId;
    if (id) this.getDetails(id);
  },
  beforeRouteUpdate(to, from, next) {
    //console.log('查询参数已更新:', to.query);
    // 在这里执行需要的操作，例如更新页面内容
    let id = to.query.courseId;
    this.getDetails(id)
  },
  methods: {
    // 映射mapMutations里的方法
    ...mapMutations(['saveCartNum']),
    // 点击查询 search
    searchBtn(val) {
      if (!val) {
        return this.$message.info("请输入查询内容");
      }
      document.cookie = "vueRouter=" + "/welfareSearchResult";
      this.$router.push({
        name: "WelfareSearchResult",
        params: {
          value: val,
        },
      });
    },
    async getDetails(courseId) {
      let params = {courseId}
      let res = await getCourseInfo(params);
      // console.log(res);
      if (res.isSuccess) {
        this.courseDetails = res.data;
      } else {
        this.$message.error(res.mag);
      }
    },
    async addCarBtn() {
      let myCartList = [];
      let mealObj = {};
      mealObj.mealID = this.courseDetails.courseId;
      mealObj.courseId = this.courseDetails.id;
      mealObj.mealName = this.courseDetails.courseName;
      mealObj.mealPrice = this.courseDetails.coursePrice;
      mealObj.mealUrl = this.courseDetails.coverUrl;
      mealObj.mealCount = 1;
      mealObj.amount = this.courseDetails.coursePrice;
      mealObj.orderType = 6;
      mealObj.festivalName = "员工学习";
      mealObj.isActive = true; // 初始化当前套餐显示为有效
      // 判断是否已在缓存中添加有购物车
      if (sessionStorage.getItem("myCartList") && !this.useInfo.privateUserID) {
        myCartList = JSON.parse(sessionStorage.getItem("myCartList"));
        // 此时是未登录状态添加进缓存
        // 判断是否有该礼包  无 则push缓存 反之
        var boo = myCartList.some((item) => {
          return item.mealID === mealObj.mealID;
        });
        if (!boo) {
          myCartList.push(mealObj);
        } else {
          // 循环判断缓存中是否有改同样礼包
          myCartList.forEach((item) => {
            // 如果有 数量相加
            if (item.mealID === mealObj.mealID) {
              item.mealCount += mealObj.mealCount;
              item.amount = item.mealCount * item.mealPrice;
            }
          });
        }
        sessionStorage.setItem("myCartList", JSON.stringify(myCartList));
        this.saveCartNum(myCartList.length);
        this.$message.success("加入购物车成功");
        // 判断是否是登录状态
      } else if (!this.useInfo.privateUserID) {
        myCartList.push(mealObj);
        sessionStorage.setItem("myCartList", JSON.stringify(myCartList));
        this.saveCartNum(myCartList.length);
        this.$message.success("加入购物车成功");
        // 已登录状态
      } else if (this.useInfo.privateUserID) {
        let data = {
          courseID: mealObj.mealID,
          courseCount: mealObj.mealCount,
        };
        const params = [data];
        // 加入购物车调登录的加入接口
        var res = await AddCourseCart(params);
        if (res.isSuccess) {
          this.$message.success(res.msg);
          // 在vuex中调用获取当前登录用户的购物车数量
          this.$store.dispatch("getLoginCartNum");
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    goRecoDetails(id) {
      this.$router.push({
        name: 'learningDetails',
        query: {courseId:id}
      })
    },
  },
};
</script>
<style lang="less" scoped>
.learning_details {
  width: 1200px;
  margin: 0 auto;
  .details_box {
    margin: 30px 0;
    display: flex;
    .details_left {
      width: 890px;
      .details_head {
        display: flex;
        .details_img {
          width: 400px;
          height: 300px;
          background-size: 100% 100%;
          border-radius: 10px;
        }
        .details_info {
          margin-top: 14px;
          margin-left: 20px;
          .info_title {
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            text-align: left;
            display: -webkit-box;
            word-break: break-all;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .info_text {
            margin-top: 22px;
            .info_name {
              display: inline-block;
              width: 70px;
              font-weight: 400;
              font-size: 14px;
              color: #333333;
              text-align-last: justify;
            }
            .info_con1 {
              font-weight: 400;
              font-size: 14px;
              color: #666666;
            }
            .info_con2 {
              font-weight: bold;
              font-size: 20px;
              color: #f64f42;
            }
          }
          .cart {
            margin-top: 38px;
          }
        }
      }
      .course_box {
        margin-top: 42px;
        /deep/.el-tabs__item {
          font-size: 16px;
        }
        .course_main {
          margin-top: 20px;
        }
        .chapter_list{
          display: block;
          margin: 20px;
          padding: 20px;
          background: #fafafa;
          .chapter_item{
            margin-top: 20px;
            height: 50px;
            line-height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #eee;
            &:nth-child(1){
              margin-top: 0;
            }
            .chapter_icon{
              position: absolute;
              display: inline-block;
              width: 3px;
              height: 15px;
              background: #ed6c00;
            }
            .chapter_title{
              max-width: 85%;
              font-size: 16px;
              font-weight: 400;
              padding-left: 20px;
              display: -webkit-box;
              word-break: break-all;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .chapter_time{
              font-size: 16px;
              font-weight: 400;
              padding-right: 20px;
            }
          }
        }
      }
    }
    .details_right {
      margin-left: 55px;
      width: 255px;
      .teacher_box {
        padding: 30px 20px;
        display: block;
        width: 253px;
        height: 382px;
        background: #f8f9fd;
        border-radius: 10px;
        border: 1px solid #eaeaea33;
        .teacher_img {
          display: block;
          margin: 0 auto;
          width: 75px;
          height: 75px;
          background-size: 100% 100%;
          border-radius: 50%;
        }
        .teacher_desc {
          margin-top: 20px;
          .teacher_desc_title {
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            line-height: 22px;
          }
          .teacher_desc_text {
            margin-top: 10px;
            display: block;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 22px;
          }
        }
      }
      .reco_box {
        margin-top: 30px;
        .reco_head {
          padding-bottom: 12px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e8e8e8;
          i {
            width: 18px;
            height: 18px;
            background: url(../../assets/img/learn/icon_reco.png) no-repeat;
            background-size: 100% 100%;
          }
          span {
            margin-left: 9px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
          }
        }
        .reco_list {
          margin-top: 20px;
          .reco_item {
            cursor: pointer;
            margin-bottom: 15px;
            border-radius: 10px;
            border: 1px solid #eef0f5;
            img {
              width: 255px;
              height: 190px;
              background-size: 100% 100%;
              border-radius: 10px 10px 0 0;
            }
            .reco_text {
              display: block;
              margin: 12px 12px;
              .reco_title {
                font-weight: 400;
                font-size: 16px;
                color: #000327;
                line-height: 24px;
                display: -webkit-box;
                word-break: break-all;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .reco_other {
                margin-top: 10px;
                display: flex;
                justify-content: space-between;
                .reco_num {
                  font-weight: 400;
                  font-size: 14px;
                  color: #333333;
                }
                .reco_price {
                  font-size: 14px;
                  font-weight: 400;
                  columns: #666;
                  i {
                    font-style: normal;
                    color: #fe6262;
                    margin-right: 2px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
